import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  status: 'idle',
};

const painDefiSlice = createSlice({
  name: "painDefi",
  initialState,
  reducers: {
    setData: (state, { payload }) => {
      state.data = payload;
      state.status = 'success';
    },
    setLoadingStatus: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setLoadingStatus, setData } = painDefiSlice.actions;

export const getData = (state) => state.painDefi.data;
export const getStatus = (state) => state.painDefi.status;
export default painDefiSlice.reducer;
